<template>
  <v-container class="custom-container">
    <v-row dense>
      <v-col cols="12">
        <v-card
          class="pa-5 live-trade-details-card"
          elevation="0"
          :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'"
        >
          <v-row class="no-gutters align-center">
            <v-col cols="12" sm="6" md="3" lg="4">
              <v-text-field
                v-model="search"
                prepend-icon="mdi-magnify"
                label="Search"
                single-line
                solo
                hide-details
                class="mt-0"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="2" lg="3">
              <v-select
                solo
                :items="slots1"
                append-icon="mdi-chevron-down"
                label="All Purpose"
                class="custom-select mt-0"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="4">
              <v-dialog
                ref="dialog"
                v-model="modal"
                :return-value.sync="date"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateRangeText"
                    prepend-icon="mdi-calendar"
                    append-icon="mdi-chevron-down"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    solo
                    class="custom-select mt-0"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date"
                  class="custom-date-picker"
                  scrollable
                  range
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    :color="$vuetify.theme.dark ? '#ff567f' : '#ff567f'"
                    text
                    @click="modal = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    :color="$vuetify.theme.dark ? '#fff' : '#131c29'"
                    text
                    @click="$refs.dialog.save(date)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="1">
              <ul class="mt-0 justify-end">
                <li>
                  <span class="">Total Count:</span>
                  <span>12032</span>
                </li>
              </ul>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="12">
              <v-card
                class="pa-0 rounded-0 elevation-0"
                :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'"
              >
                <v-sheet
                  class="transactionTable depositTabTable registerUserTable"
                  :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'"
                >
                  <v-data-table
                    :headers="headers"
                    :items="Transaction"
                    :items-per-page="7"
                  >
                    <template v-slot:item.otpView="{ item }">
                      <div :class="item.otpClass">
                        {{ item.otpView }}
                      </div>
                    </template>
                    <template v-slot:item.statusView="{ item }">
                      <div :class="item.statusClass">
                        {{ item.statusView }}
                      </div>
                    </template>
                  </v-data-table>
                </v-sheet>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      search: "",
      modal: false,
      dialog: false,
      date: ["2022-01-01", "2023-01-01"],
      slots1: ["Lorem Ipsume 1", "Lorem Ipsume 2", "Lorem Ipsume 3"],
      slots2: ["Lorem Ipsume 1", "Lorem Ipsume 2", "Lorem Ipsume 3"],
      headers: [
        { text: "SL", align: "start", value: "SlView" },
        { text: "Email From", value: "EmailFrom" },
        { text: "Email To", value: "EmailTo" },
        { text: "Subject", value: "SubjectView" },
        { text: "OTP", value: "otpView" },
        { text: "Status", value: "statusView" },
        { text: "Date & Time", value: "DateTimeView" },
      ],
      Transaction: [
        {
          SlView: 1,
          EmailFrom: "backoffice@forexcrm.com",
          EmailTo: "bappy.mithun@gmail.com",
          SubjectView: "Forexcrm Demo Account Detail",
          otpView: "NA",
          otpClass:"text-disabled",
          statusView: "NA",
          statusClass:"text-disabled",
          DateTimeView: "12/10/24 3:23PM",
        },
        {
          SlView: 2,
          EmailFrom: "backoffice@forexcrm.com",
          EmailTo: "bappy.mithun@gmail.com",
          SubjectView: "Forexcrm Demo Account Detail",
          otpView: "738488",
          otpClass:"",
          statusView: "Verified",
          statusClass:"bg-success",
          DateTimeView: "12/10/24 3:23PM",
        },
        {
          SlView: 3,
          EmailFrom: "backoffice@forexcrm.com",
          EmailTo: "bappy.mithun@gmail.com",
          SubjectView: "Forexcrm Demo Account Detail",
          otpView: "NA",
          otpClass:"text-disabled",
          statusView: "Not Verified",
          statusClass:"bg-danger px-2",
          DateTimeView: "12/10/24 3:23PM",
        },
      ],
    };
  },
  computed: {
    dateRangeText() {
      return this.date.join(" ~ ");
    },
  },
};
</script>
